<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'stock-adjustment-list'"
    :setLoading="setLoading"
    :loadDataGrid="loaded"
    v-if="loaded"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FeatureStorage } from "../../_services/storage";
import { StockAdjustmentService } from "@/_services/api/inventory/stock-adjustment.service";
import TransactionListTemplate from "../../templates/transaction-list";
import ColumnWidth from "@/_helpers/data-grid/ColumnWidth";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      setLoading: false,
      loaded: false,
    };
  },
  computed: {
    setScreenConfig() {
      return {
        title: "Stock Adjustments",
        ScreenName: "Stock Adjustments - All",
        selectedIndex: 0,
        tabs: [
          {
            text: "All",
            path: `/stock-adjustment`,
            applicationFeatureCode: "StockAdjustment",
          },
        ],
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "StockAdjustment",
              serverPaging: true,
              allowGrouping: false,
              select: [
                "Code",
                "Status",
                "DateIn",
                "CreatedBy",
                "LineInfo",
                "FriendlyStatus",
                "Status",
                "BranchCodeList",
                "DateCreated",
                "ItemCodeList",
                "AdjustmentTotal"
                // "Product",
              ],
            },
            // rowSelect: {
            //   view: this,
            //   page: "stock-adjustment",
            //   mode: "review",
            //   idProperty: "Code",
            // },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Adjustments",
                message: "Get Started, Adjust Stock",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: false,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: this.getScreenNavigation(
                  "StockAdjustmentVersionInUse",
                  "stock-adjustment"
                ),
                // "/stock-adjustment/create",
                routeAction: () => {
                  if (this.formsConfig.editableOption) {
                    return this.getScreenNavigation(
                      "StockAdjustmentVersionInUse",
                      "stock-adjustment"
                    );
                  } else {
                    return "/unauthorized";
                  }
                },
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              dataField: "PurchaseOrder",
              gridDataField: "Code",
              sortOrder: "desc",
              sortIndex: 0,
              allowHiding: false,
              fixed: true,
              fixedPosition: "left",
              minWidth: ColumnWidth.DateCreated.minWidth,
              width: ColumnWidth.DateCreated.width + 20,
              label: "Adjustment",
              filterIndex: 0,
              type: "Integer",
              filterDataField: "Code",
              filterLabel: "Adjustment",
              forceWidth: true,
            },
            {
              screenField: "DateIn",
              label: "Date",
              filterIndex: 1,
              minWidth: ColumnWidth.DateCreated.minWidth,
              width: ColumnWidth.DateCreated.width,
            },
            {
              screenField: "LineComment",
              dataField: "LineInfo",
              gridLabel: "# Lines",
              minWidth: ColumnWidth.LineNo.minWidth,
              width: ColumnWidth.LineNo.width,
            },
            {
              screenField: "DateCreated",
              label: "Date Created",
              filterIndex: 3,
              minWidth: ColumnWidth.DateCreated.minWidth,
              width: ColumnWidth.DateCreated.width,
            },
            {
              screenField: "CreatedBy",
              dataField: "CreatedBy",
              gridLabel: "Created By",
              filterLabel: "Created By",
              filterIndex: 7,
              dataSourceConfig: {
                endpoint: "api/Users",
                sort: {
                  "selector": "Username",
                  "asc": true
                },
              },
              // minWidth: ColumnWidth.Username.minWidth,
              // width: "auto",
            },
            {
              screenField: "AdjustmentTotal",
              dataField: "AdjustmentTotal",
              gridLabel: "Adjustment Value",
              filterLabel: "Adjustment Value",
              type: "Decimal",
              format: "Decimal-16-2",
              minWidth: ColumnWidth.Price2DecimalPoints.minWidth,
              width: ColumnWidth.Price2DecimalPoints.width,
            },
            {
              screenField: "Branch",
              filterIndex: 5,
              visible: false,
              filterDataField: "BranchCodeList",
            },
            {
              screenField: "Product",
              visible: false,
              filterLabel: "Product",
              filterIndex: 6,
              filterOperator: "contains",
              gridDataField: "ItemCodeList",
              filterDataField: "ItemCodeList",
              dataSourceConfig: {
                endpoint: "api/Product",
                sort: {
                  "selector": "Description1",
                  "asc": true
                },
              }
            },
            {
              screenField: "OrderStatus",
              gridDataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              filterIndex: 4,
              dataSourceConfig: {
                data: ["Completed"],
              },
            },
            {
              screenField: "GridRecordEmail",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordPDFView",
              cssClass: "padding-7",
            },
            {
              screenField: "GridRecordPrint",
              cssClass: "padding-7",
              ReferenceNoField: "Code",
            },
            {
              screenField: "GridRecordEllipsisMenu",
              cssClass: "padding-7",
              allowSearch: false,
              ellipsisMenu: {
                itemAction: (data) => {
                  return [
                    {
                      menuText: "Copy",
                      data: data,
                      visible: FeatureStorage.checkPermission(
                        "StockAdjustment",
                        "create"
                      ),
                      clickAction: this.copyStockAdjustmentFromList,
                    },
                    {
                      menuText: "Reverse",
                      data: data,
                      visible:
                        FeatureStorage.checkPermission(
                          "StockAdjustment",
                          "create"
                        ) && data.data.Status === "A",
                      clickAction: this.onReverseClickHandle,
                    },
                  ];
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: () => {
                return !FeatureStorage.checkPermission(
                  "StockAdjustment",
                  "create"
                );
              },
            },
          ],
        },
      };
    },
  },
  methods: {
    rowClickCallBack(e) {
      if (
        e.rowType === "data" &&
        e.column.screenField !== "GridRecordEmail" &&
        e.column.screenField !== "GridRecordPDFView" &&
        e.column.screenField !== "GridRecordPrint" &&
        e.column.screenField.toString() !== "GridRecordEllipsisMenu"
      ) {
        this.onRowClicked(e, {
          view: this,
          page: this.getScreenRowClickNavigation(
            "StockAdjustmentVersionInUse",
            "stock-adjustment"
          ),
          mode: "review",
          idProperty: "Code",
        });
      }
    },
    copyStockAdjustmentFromList(e) {
      this.$router.push({
        path: `/stock-adjustment-v2/create/${e.Code}`,
        query: {
          copy: true,
        },
      });
    },
    async onReverseClickHandle(e, grid) {
      const confirmLeaving = await this.$confirm(
        `Are you sure you want to reverse this Stock Adjustment #${e.Code}? This action cannot be undone.`,
        "Reverse Stock Transfer",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
        }
      );
      if (confirmLeaving) {
        this.setLoading = true;
        await StockAdjustmentService.reverse(e.Code)
          .then((res) => {
            this.$notify(
              `Reversal of Stock Adjustment #${e.Code} is successful`,
              "success"
            );
            if (res) this.setLoading = false;
            grid.refresh(true);
          })
          .catch((err) => {
            this.setLoading = false;
            this.$store.dispatch("ui/setServerError", {
              error: err,
              title: "Reverse Stock Adjustment Failed",
            });
          });
      }
    },
  },

  async created() {
    this.setLoading = true;
    await this.setScreenNavigation("StockAdjustmentVersionInUse");
    this.loaded = true;
  },
};
</script>

<style lang="scss"></style>
